// src/components/tabs/TrailerTab.jsx
import React from 'react';
import './TrailerTab.css';

function TrailerTab({ movie }) {
  if (!movie) return <div>No movie selected</div>;
  
  // Extract trailer URL from movie data
  const trailerUrl = movie.trailer_url;
  
  // Function to convert YouTube URL to embed URL
  const getEmbedUrl = (url) => {
    if (!url) return null;
    
    // Check if it's a YouTube URL
    const youtubeRegex = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/;
    const match = url.match(youtubeRegex);
    
    if (match && match[1]) {
      return `https://www.youtube.com/embed/${match[1]}`;
    }
    
    return null;
  };
  
  const embedUrl = getEmbedUrl(trailerUrl);

  return (
    <div className="trailer-tab">
      <h2>Trailer</h2>
      
      {embedUrl ? (
        <div className="trailer-container">
          <iframe 
            src={embedUrl}
            title={`${movie.title} Trailer`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="trailer-frame"
          ></iframe>
        </div>
      ) : (
        <div className="no-trailer">
          <p>Official trailer not available for this movie.</p>
          <p>Try searching for "{movie.title} trailer" on YouTube.</p>
        </div>
      )}
      
      <div className="trailer-info">
        {trailerUrl && (
          <a 
            href={trailerUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="youtube-link"
          >
            Watch on YouTube
          </a>
        )}
      </div>
    </div>
  );
}

export default TrailerTab;